import { render, staticRenderFns } from "./px-form-modal.vue?vue&type=template&id=202d3092&scoped=true&"
import script from "./px-form-modal.vue?vue&type=script&lang=ts&"
export * from "./px-form-modal.vue?vue&type=script&lang=ts&"
import style0 from "./px-form-modal.vue?vue&type=style&index=0&id=202d3092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d3092",
  null
  
)

export default component.exports